<template>
    <!-- Page Header -->
    <div class="flex items-center justify-between pb-3">
        <h4 class="font-bold mb-0">{{ t('maintenance.title') }}</h4>
    </div>
    <div class="space-y-4 pb-4">

        <!-- Filters -->
        <MaintenanceFilters v-model:dateRange="dateRange" v-model:selectedQuickPeriod="selectedQuickPeriod"
            :quickPeriodOptions="quickPeriodOptions" @applyQuickPeriod="applyQuickPeriod"
            @dateRangeChange="onDateRangeChange" />

        <!-- Timeline -->
        <MaintenanceTimeline :loading="loading" :resources="allResourcesWithMaintenance"
            :timelineStart="getTimelineStart()" :timelineEnd="getTimelineEnd()" :todayPosition="getTodayPosition()"
            :getResourceStatusClass="getResourceStatusClass" :getResourceStatusText="getResourceStatusText"
            :getMaintenanceColor="getMaintenanceColor" :getMaintenanceBorderClass="getMaintenanceBorderClass"
            :getMaintenancePosition="getMaintenancePosition" :getStatusClass="getStatusClass"
            :getStatusLabel="getStatusLabel" :formatDateRange="formatDateRange" :formatTimeRange="formatTimeRange"
            @openSchedule="handleOpenSchedule" />

        <!-- Schedule Dialog -->
        <MaintenanceScheduleDialog v-model:visible="dialogVisible" :resourceName="resourceName" :resourceType="resourceType" :resourceCapacity="resourceCapacity" :slots="form.slots"
            :saving="saving" :validationError="validationError" :conflicts="conflicts" @addSlot="addSlot" @removeSlot="removeSlot"
            @updateSlot="updateSlot" @setBlockingMode="setBlockingMode" @save="handleSave" />
    </div>
</template>

<script setup lang="ts">
import MaintenanceFilters from '@/components/maintenances/MaintenanceFilters.vue';
import MaintenanceScheduleDialog from '@/components/maintenances/MaintenanceScheduleDialog.vue';
import MaintenanceTimeline from '@/components/maintenances/MaintenanceTimeline.vue';
import { useMaintenanceScheduleDialog } from '@/composables/useMaintenanceScheduleDialog';
import { useMaintenancesPage } from '@/composables/useMaintenancesPage';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

// Page logic
const {
    loading,
    dateRange,
    selectedQuickPeriod,
    quickPeriodOptions,
    allResourcesWithMaintenance,
    getStatusLabel,
    getStatusClass,
    getResourceStatusClass,
    getResourceStatusText,
    getMaintenanceColor,
    getMaintenanceBorderClass,
    getTimelineStart,
    getTimelineEnd,
    getTodayPosition,
    getMaintenancePosition,
    formatDateRange,
    formatTimeRange,
    applyQuickPeriod,
    onDateRangeChange,
    fetchTimespans,
    initialize
} = useMaintenancesPage();

// Dialog logic
const {
    dialogVisible,
    saving,
    validationError,
    conflicts,
    form,
    resourceName,
    resourceType,
    resourceCapacity,
    addSlot,
    removeSlot,
    updateSlot,
    setBlockingMode,
    openSchedule,
    saveMaintenance
} = useMaintenanceScheduleDialog();

async function handleOpenSchedule(resourceId: string) {
    await openSchedule(resourceId);
}

async function handleSave() {
    await saveMaintenance(async () => {
        await fetchTimespans();
    });
}

onMounted(() => {
    initialize();
});
</script>
